/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { actions } from '../actionTypes';
import { anyTodo, ISoftware, IdValueObj } from '@umati/dashboard-types';
import { SoftwareHandling } from 'utilities/SoftwareHandling';
import { getSoftwares } from '../../api/softwares';
import { Action, Reducer } from 'redux';

export interface ISoftwareStore {
  Softwares: IdValueObj<ISoftware>;
  favourites: string[];
  apiError: anyTodo | null;
}

export const initialSoftwaresState: ISoftwareStore = {
  Softwares: {},
  // Dummy, bug in redux-persist, empty array gets converted to null
  favourites: ['umati_dashboard'],
  apiError: null
};

const softwares = (state = initialSoftwaresState, action): ISoftwareStore | undefined => {
  switch (action.type) {
    case actions.LOAD_SOFTWARES_SUCCESS:
    {
      const newSoftwares = SoftwareHandling.setFavorite(action.payload, state.favourites);
      return {
        ...state, Softwares: newSoftwares
      };
    }
    case actions.LOAD_SOFTWARE_SUCCESS:
    {
      const newSoftwares = SoftwareHandling.setFavorite(state.Softwares, state.favourites);
      return {
        ...state, Softwares: newSoftwares
      };
    }
    case actions.SET_SOFTWARE_FAVOURITES:
      return { ...state, favourites: [...new Set<string>(action.payload.favourites)] };
    case actions.SET_SOFTWARE_FAVOURITE:
    {
      const softwareId: string = action.payload.softwareId;
      const favourite: boolean = action.payload.favourite;
      const favourites = new Set<string>(state.favourites);
      if (favourite) {
        favourites.add(softwareId);
      } else {
        favourites.delete(softwareId);
      }
      const newSoftwares = SoftwareHandling.setFavorite(state.Softwares, [...favourites]);
      state = {
        ...state,
        favourites: [...favourites],
        Softwares: newSoftwares
      };
      return state;
    }
    default: {
      return { ...state, favourites: state.favourites?.length > 0 ? state.favourites : [] };
    }
  }
};

const persistConfig = {
  key: 'softwares',
  storage,
  blacklist: ['Softwares', 'apiError']
};

export async function fetchSoftware (dispatch /* , getState */) {
  try {
    const response = await getSoftwares();
    const softwares = SoftwareHandling.deserializeSoftwaresFromBackendRequest(response);
    dispatch({ type: actions.LOAD_SOFTWARES_SUCCESS, payload: softwares });
  } catch (error) {
    dispatch({ type: actions.LOAD_SOFTWARES_ERROR, payload: error });
  }
}

export default persistReducer(persistConfig, softwares as Reducer<ISoftwareStore, Action>);
